<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<b-table
			v-else-if="tableItems.length > 0"
			:items="tableItems"
			:fields="fields"
			small
			bordered
		>
			<template #cell(label)="{ value }">
				<span class="d-block text-center">{{ value }}</span>
			</template>
			<template #cell(value)="{ value }">
				<span class="d-block text-center">{{ value }}</span>
			</template>
		</b-table>
		<span v-else class="d-block text-center">{{ $t('cards.widget.physiological_states_empty') }}</span>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetPhysiologicalStates',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			tableItems: [],
			fields: [
				{ key: 'label', label: this.$t('cards.widget.col_physiological_state') },
				{ key: 'value', label: this.$t('cards.widget.col_mare_count') },
			],
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			// L'API renvoie { label, value } : label = résultat du DG le plus récent
			// de la jument (ex. « DG+ »), ou « Non saillie » si aucun DG.
			this.tableItems = await this.getPhysiologicalStateStats()
			this.loading = false
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
